export const resolve = (object, properties, defaultValue) => {
  let safeAssignedValue;

  if (properties && typeof properties === 'string') {
    const propertiesListRegExp = /(?:([\w\s]+)\s?)/g; // match all values between . or ' or " or []

    try {
      safeAssignedValue = properties
        .match(propertiesListRegExp)
        .reduce((item, initValue) => {
          if (
            Object.prototype.hasOwnProperty.call(item, initValue) &&
            item[initValue] !== undefined &&
            item[initValue] !== null
          ) {
            return item[initValue];
          } // eslint-disable-next-line
          throw {
            // eslint-disable-next-line
            error: 'Reference error! Properties is not defined',
          };
        }, object);
    } catch (e) {
      safeAssignedValue = defaultValue;
    }
  }
  return safeAssignedValue !== undefined ? safeAssignedValue : null;
};
